angular.module('storefront.account')
    .component('vcAccountProfileUpdate', {
        templateUrl: 'themes/assets/js/account/account-profile-update.tpl.liquid',
        bindings: {
            $router: '<',
        },
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: [
            'storefrontApp.mainContext',
            '$scope',
            'loadingIndicatorService',
            function (
                mainContext,
                $scope,
                loader,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;
                $ctrl.newEmail = '';
                $ctrl.confrimEmail = '';

                $scope.setForm = function (form) {
                    $scope.form = form;
                };

                $scope.$watch(
                    function () {
                        return mainContext.customer;
                    },
                    function (customer) {
                        $ctrl.customer = customer;

                        if (customer) {
                            $ctrl.changeData = {
                                firstName: customer.firstName,
                                lastName: customer.lastName,
                                email: customer.email,
                                phones: customer.phones,
                            };
                        }
                    },
                );

                $ctrl.submit = function () {
                    $scope.form.$setSubmitted();

                    if ($scope.form.$valid && $ctrl.newEmail === $ctrl.confrimEmail) {
                        $ctrl.changeData.email = $ctrl.newEmail || $ctrl.changeData.email;
                        $ctrl.accountManager.updateProfile($ctrl.changeData)
                            .then((response) => {
                                if (response.succeeded) {
                                    $ctrl.newEmail = '';
                                    $ctrl.confrimEmail = '';
                                } else {
                                    angular.extend($ctrl, response);
                                }
                            });
                    }
                };

                $ctrl.showChangePasswordDialog = function () {
                    $ctrl.changePasswordDialogVisible = true;
                };

                $ctrl.changePasswordDialogClose = function () {
                    $ctrl.changePasswordDialogVisible = false;
                };
            }],
    });
